import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { MdInfoOutline } from 'react-icons/md';
import './PermissionHelp.css';

export default function PermissionHelp({ label, description }) {
  return (
    <Tooltip
      title={description}
      placement="top"
      arrow
      enterTouchDelay={0}
      classes={{ tooltip: 'member-permission-tooltip' }}
    >
      <button
        type="button"
        className="member-permission-help hidethis"
        aria-label={`Sobre ${label}`}
      >
        <MdInfoOutline aria-hidden="true" />
      </button>
    </Tooltip>
  );
}
